export default "__VITE_ASSET__BIl$bEy4__"